import React, { Component} from 'react';
import { FacebookProvider, Comments } from 'react-facebook';
 
export default class Example extends Component {
  render() {
    return (
      <FacebookProvider appId="243407530453003">
        <Comments href="https://dim0147.github.io/dyl-editor" />
      </FacebookProvider>
    );
  }
}